/**
 * This file is auto-generated. DO NOT EDIT MANUALLY.
 */

export const configRegistry = {
    2471: () => import('../config/institutionConfig/2471.config'),
    2512: () => import('../config/institutionConfig/2512.config'),
    bbok: () => import('../config/institutionConfig/bbok.config'),
    default: () => import('../config/institutionConfig/default.config'),
    tcm: () => import('../config/institutionConfig/tcm.config'),
};